import { render, staticRenderFns } from "./PerformerComparison.vue?vue&type=template&id=4c1fc2a7&scoped=true&"
import script from "./PerformerComparison.vue?vue&type=script&lang=js&"
export * from "./PerformerComparison.vue?vue&type=script&lang=js&"
import style0 from "./PerformerComparison.vue?vue&type=style&index=0&id=4c1fc2a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1fc2a7",
  null
  
)

export default component.exports